const LINK_GROUPS = [
  {
    title: "栏目导航",
    links: [
      { label: "今日瓜", href: "#today" },
      { label: "现场直击", href: "#scene" },
      { label: "热点话题", href: "#trend" },
      { label: "关于瓜场", href: "#about" },
    ],
  },
  {
    title: "内容原则",
    links: [
      { label: "不追隐私", href: "#about" },
      { label: "先核实再说", href: "#about" },
      { label: "理性吃瓜", href: "#faq" },
      { label: "投稿线索", href: "#faq" },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-lg font-bold text-background-50">
                瓜
              </span>
              <span className="text-lg font-bold text-white">瓜场 · 今日瓜</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              国产吃瓜今日瓜、现场与快讯的聚合站点。想第一时间知道大家在聊什么，点开这里看热点追踪的实时同步，不错过任何一场热闹。
            </p>
            <a
              href="mailto:guachang@example.com"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm text-white transition-colors hover:bg-white/20"
            >
              <i className="ri-mail-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              guachang@example.com
            </a>
          </div>

          {LINK_GROUPS.map((g) => (
            <nav key={g.title} aria-label={g.title}>
              <h3 className="text-sm font-semibold text-white">{g.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-background-300 transition-colors hover:text-white">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © {year} 瓜场 GuaChang · 内容聚合整理，仅为信息交流分享。
          </p>
          <p className="text-xs text-background-400">理性吃瓜，快乐聊天 · 让热点回归信息本身</p>
        </div>
      </div>
    </footer>
  );
}